"use client";

import { useAuthErrorHandler } from "@/hooks/use-auth-error-handler";

/**
 * Auth Error Provider Component
 *
 * This component wraps the application with global authentication error handling.
 * It uses the useAuthErrorHandler hook to listen for 401 errors and automatically
 * log out users when authentication fails.
 *
 * Must be a client component to use hooks and event listeners.
 */
export function AuthErrorProvider({ children }: { children: React.ReactNode }) {
  // Initialize the auth error handler
  useAuthErrorHandler();

  // Simply render children - the hook handles all the error listening
  return <>{children}</>;
}
